import { render, staticRenderFns } from "./EventCalendar.vue?vue&type=template&id=280c675f&"
import script from "./EventCalendar.vue?vue&type=script&lang=js&"
export * from "./EventCalendar.vue?vue&type=script&lang=js&"
import style0 from "./EventCalendar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EventCalendar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports